import React from 'react';
import { FormControl } from 'react-bootstrap';

const SearchField = (props) => {
	const { input, onKeyDown } = props;
	return (	
		<FormControl 
			componentClass='input' 
			type='text' 
      placeholder='Enter a keyword to search jobs'
      name={input.name} 
      onChange={input.onChange} 
      value={input.value}
      autoComplete='off'
      onKeyDown={onKeyDown}
		/>
	);
};

export default SearchField;
